import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() => import("views/auth-views/authentication/login"))
  }
];

export const protectedRoutes = [
  {
    key: "app-dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/dashboard")),
    meta: {
      showAccess: true
    }
  },
  {
    key: "app-pmk-employee",
    path: `${APP_PREFIX_PATH}/pmk/employee/*`,
    component: React.lazy(() => import("views/app-views/pmk/employee"))
  },
  {
    key: "app-pmk-importemployee",
    path: `${APP_PREFIX_PATH}/pmk/import-employee/*`,
    component: React.lazy(() => import("views/app-views/pmk/import-employee"))
  },
  {
    key: "app-pmk-transaction",
    path: `${APP_PREFIX_PATH}/pmk/transaction/*`,
    component: React.lazy(() => import("views/app-views/pmk/transaction"))
  },
  {
    key: "app-pmk-company",
    path: `${APP_PREFIX_PATH}/pmk/company/*`,
    component: React.lazy(() => import("views/app-views/pmk/company"))
  },
  {
    key: "app-personal",
    path: `${APP_PREFIX_PATH}/personal`,
    component: React.lazy(() => import("views/app-views/personal"))
  }
];
